import { SocialNetworkTypes } from './social-network-types';

export default class SocialNetworkData {
    ExternalId: string = '';
    Type: SocialNetworkTypes = SocialNetworkTypes.VK;
    AccessToken: string = '';
}